import TreeOfGrowthTimeline from '../components/TreeOfGrowthTimeline';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
export default function OurEffortsSection() {
  return <div style={{background:'#f5f3ed'}}><SiteHeader /><main><TreeOfGrowthTimeline /></main><SiteFooter /></div>;
}
